import React, { useState, useContext } from 'react';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { MainContext } from '../App';
import apiService from '../api';

const DriverRegistrationPage = () => {
  const { setProgress } = useContext(MainContext);
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await apiService.registerDriver(
        { name, phone: phoneNumber },
        setProgress,
        handleError
      );

      if (response.message) {
        setMessage(response.message);
        setName('');
        setPhoneNumber('');
      }
    } catch (err) {
      handleError(err);
    }
  };

  const handleError = (err) => {
    if (err.status === 400) {
      err.json().then(data => {
        setError(data.error || 'İsim veya telefon numarası eksik');
      }).catch(() => {
        setError('İsim veya telefon numarası eksik');
      });
    } else {
      setError('Kayıt gönderilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    }
    console.error(err);
  };

  return (
    <Container className="mt-5">
      <h2>Şoför Kayıt Formu</h2>
      {message && <Alert variant="success">{message}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>İsim</Form.Label>
          <Form.Control
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="İsminizi girin"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Telefon Numarası</Form.Label>
          <Form.Control
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            placeholder="Telefon numaranızı girin"
          />
        </Form.Group>
        <Button variant="primary" type="submit">
          Gönder
        </Button>
      </Form>
    </Container>
  );
};

export default DriverRegistrationPage;
